export default {"src":"/_next/static/media/EyeInjuries.a33e9ff7.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};